
<template>

    <div id="sharePage">

        <div class="sharePage-img">
            <img :src="imgSave64" />
        </div>

        <div class="sharePage-one">
            <div class="circle-btn" @click="$emit('on-setIndex', 'camaraGaleria')" ><img :src="baseURL+'/modules/supercheckout/images/repetir.png'" ></div>
            <a class="circle-btn" :href="producto.link" ><img :src="baseURL+'/modules/supercheckout/images/comprar.png'" ></a>
            <div class="circle-btn" @click="btnImgDow" ><img :src="baseURL+'/modules/supercheckout/images/download.png'" ></div>
            <div class="circle-btn" @click="btnSocials" ><img :src="baseURL+'/modules/supercheckout/images/compartir.png'" ></div>
        </div>

        <div class="sharePage-one">

            <div class="sharePage-social">

                <div class="jssocials-shares-loading">

                    <span class="icon1-spinner"></span>

                </div>

                <div class="jssocials-shares">

                    <div class="jssocials-share jssocials-share-twitter">
                        <a target="_blank" :href="'https://twitter.com/share?url='+shareLink+'&text='+producto.titulo_share" class="jssocials-share-link">
                            <i class="icon-twitter jssocials-share-logo"></i>
                        </a>
                        <div class="jssocials-share-count-box jssocials-share-no-count">
                            <span class="jssocials-share-count"></span>
                        </div>
                    </div>

                    <div class="jssocials-share jssocials-share-facebook">
                        <a target="_blank" :href="'https://facebook.com/sharer/sharer.php?u='+shareLink" class="jssocials-share-link">
                            <i class="icon-facebook jssocials-share-logo"></i>
                        </a>
                        <div class="jssocials-share-count-box jssocials-share-no-count">
                            <span class="jssocials-share-count"></span>
                        </div>
                    </div>
                    
                    <div class="jssocials-share jssocials-share-googleplus">
                        <a target="_blank" :href="'https://plus.google.com/share?sharefrom=googleplus&url='+shareLink" class="jssocials-share-link">
                            <i class="icon1-google jssocials-share-logo"></i>
                        </a>
                        <div class="jssocials-share-count-box jssocials-share-no-count">
                            <span class="jssocials-share-count"></span>
                        </div>
                    </div>
                    
                    <div class="jssocials-share jssocials-share-messenger">
                        <a target="_blank" :href="'fb-messenger://share?link='+shareLink" class="jssocials-share-link">
                            <i class="icon1-messenger jssocials-share-logo"></i>
                        </a>
                        <div class="jssocials-share-count-box jssocials-share-no-count">
                            <span class="jssocials-share-count"></span>
                        </div>
                    </div>
                    
                    <div class="jssocials-share jssocials-share-pinterest">
                        <a target="_blank" :href="'https://pinterest.com/pin/create/bookmarklet/?url='+shareLink" class="jssocials-share-link">
                            <i class="icon1-pinterest jssocials-share-logo"></i>
                        </a>
                        <div class="jssocials-share-count-box jssocials-share-no-count">
                            <span class="jssocials-share-count"></span>
                        </div>
                    </div>
                    
                    <div class="jssocials-share jssocials-share-whatsapp">
                        <a target="_blank" :href="'https://api.whatsapp.com/send?text='+shareLink" class="jssocials-share-link">
                            <i class="icon-whatsapp jssocials-share-logo"></i>
                        </a>
                        <div class="jssocials-share-count-box jssocials-share-no-count">
                            <span class="jssocials-share-count"></span>
                        </div>
                    </div>

                    <div class="jssocials-share jssocials-share-telegram">
                        <a target="_blank" :href="'https://telegram.me/share/url?url='+shareLink" class="jssocials-share-link">
                            <i class="icon-telegram jssocials-share-logo"></i>
                        </a>
                        <div class="jssocials-share-count-box jssocials-share-no-count">
                            <span class="jssocials-share-count"></span>
                        </div>
                    </div>

                </div>

            </div>

        </div>

    </div>

</template>


<script>

export default {

    props: ['imgSave64', 'producto'],

    data(){
        return {
            title: 'categorias',
            shareLink: null,
            baseURL: baseURL,
            flagUploadComplete: false,
        }
    },

    mounted: function () {
 
        
    },
    methods: {
    
        btnImgDow: function(){  

            const link = document.createElement('a')
            link.download = 'img-tryon.jpeg'
            link.href = this.imgSave64
            link.click()

        },
        
        btnSocials: function(){

            const _this = this

            if(this.flagUploadComplete == true) return null

            // console.log( this.imgSave64 )

            var fdata = new FormData();

            // fdata.append("id_product", this.producto.id);
            fdata.append("capture64", this.imgSave64);

            if($('.jssocials-shares.active').length <= 0){
                $('.jssocials-shares-loading').addClass('active')
            }

            $.ajax({
                type: 'POST',
                url: `${linkModulo}?save_image=1`,
                data: fdata,
                contentType: false,
                processData: false,
                success: function(response){

                    _this.flagUploadComplete = true

                    $('.jssocials-shares-loading').removeClass('active')

                    if($('.jssocials-shares.active').length > 0){
                        $('.jssocials-shares.active').removeClass('active')
                    }else{
                        $('.jssocials-shares').addClass('active')
                    }
    
                    let responseJson = JSON.parse(response)

                    _this.shareLink = encodeURIComponent(`${linkModulo}?image_show=1&x=${_this.producto.id}&y=${responseJson.name}`)

                }
            })


        }

    }
}


</script>


<style lang="scss">

    #sharePage{
        padding: 40px 10px 0 10px;
        max-width: 420px;
        margin: 20px 0px;

        width: 95%;

        border: 3px solid #ed3a5b;
        border-radius: 41px;

        .sharePage-img{
            width: 250px;
            margin: 0 auto;
            box-shadow: 0 3px 6px rgba(0,0,0,.16), 0 3px 6px rgba(0,0,0,.23);

            img{ width: 100%; }

        }


        .sharePage-one{
            margin: 20px 0;
            display: flex;
            justify-content: center;
            align-items: center;

            .sharePage-circle{
                border-radius: 50%;
                border: 1px solid;
                min-width: 120px;
                min-height: 120px;
                height: 120px;
                width: 120px;
                padding: 2px;
                margin: 10px;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 19px;

                span{
                    width: 100%;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }

                &:hover span{
                    border: solid;
                    border-radius: 50%;
                }

            }

        }

        .sharePage-social{
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden;
            position: relative;
        }

        .jssocials-shares-loading{
            position: absolute;
        }

        .jssocials-shares, .jssocials-shares-loading{
            display: flex;
            font-size: 20px;
            margin: 20px 0px;
            transition-duration: .5s;
            transform: translate(0, 66px);
        }

        .jssocials-shares.active, .jssocials-shares-loading.active{
            transform: translate(0, 0);
        }

        .jssocials-shares-loading{
            position: absolute;

            &.active{
                transform: translateY(-20px);
            }

        }


        .jssocials-share {
            margin: 0 5px;
            display: flex;
            align-items: center;
        }

        .jssocials-shares{

        
            a{
                color: #666f7e;

                &:hover{
                    color: #ed3a5b;
                }

            }

            i[class*="pinterest"]:before, i[class*="whatsapp"]:before {
                font-size: 36px;
            }

        }


        .icon1-spinner{
            font-size: 30px;
            animation-name: spin;
            animation-duration: 1000ms;
            animation-iteration-count: infinite;
            animation-timing-function: linear;
            
            &:before{
                padding: inherit;
            } 
        }

        @keyframes spin {
            from {
                transform:rotate(0deg);
            }
            to {
                transform:rotate(360deg);
            }
        }

        

    }

    #virtual-image .sharePage-one .circle-btn {
        width: 60px;
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 5px;

        img{
            max-width: 38px;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/SharePage.vue